import { render, staticRenderFns } from "./partnersList.vue?vue&type=template&id=a98def9c&scoped=true&"
import script from "./partnersList.vue?vue&type=script&lang=js&"
export * from "./partnersList.vue?vue&type=script&lang=js&"
import style0 from "./partnersList.vue?vue&type=style&index=0&id=a98def9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98def9c",
  null
  
)

export default component.exports